import axios from 'axios';
const state= {
  checklist: {},
  checklistLoading: {
    listing: false,
  },
  error: {}
};

const getters = {
  errorResponse : (state) => state.error,
  checklistItem : (state) => state.checklist,
  checklistLoading: (state) => state.checklistLoading
};

const actions = {
  async getCheckList({commit}, params){
    return new Promise (( resolve, reject ) => {
      commit( 'setChecklistLoading', true )
      global.axios(`api/contracts/${params.contract_id}/checklists/${params.checklist_id}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
        }
      })
      .then(response => {
        if(response.data.status == 200) {
          commit( 'setChecklist', response.data.data )
        }
        if(response.data.status == 200 && response.data.data != null && response.data.data.hasOwnProperty('code')) {
          commit( 'setError', response.data.data )
        }
        commit( 'setChecklistLoading', false )
        resolve( response )
      })
      .catch(error => reject( error ))
    });
  },
  updateCheckList({commit}, params){
    return new Promise (( resolve, reject ) => {
      commit( 'setChecklistLoading', true )
      global.axios.put(`api/checklist/${params.checklist_id}`, params.checklists)
          .then(response => {
            commit( 'setChecklistLoading', false )
            resolve( response )
          })
          .catch(error => reject( error ))
    });
  },
  updateCheckListJob({commit}, params){
    return new Promise (( resolve, reject ) => {
      commit( 'setChecklistLoading', true )
      global.axios.put(`/api/checklist-entries/multiple`, params)
          .then(response => {
            commit( 'setChecklistLoading', false )
            resolve( response )
          })
          .catch(error => reject( error ))
    });
  },
  async updateFollowUp({commit}, params){
    return new Promise (( resolve, reject ) => {
      let formData = new FormData();
      for( var i = 0; i < params.action.photos.length; i++ ){
          let photo = params.action.photos[i];
          formData.append('photos[' + i + ']', photo);
      }
      formData.append('description', params.data.description || '');
      formData.append('remark_type', params.data.remark_type);
      formData.append('isfollowUp', params.isfollowUp);
      formData.append('iskeepNextJob', params.iskeepNextJob);
      formData.append('index', params.data.key_of_list);
      formData.append('sla_id', params.sla_id || '');
      formData.append('preset_actions', params.data.preset_actions || '');
      formData.append('action_taken_description', params.action_taken_description || '');
      formData.append('action_taken_date_rectified', params.action_taken_date_rectified || '');

      if(params.action_taken_photos.length) {
        for( var i = 0; i < params.action_taken_photos.length; i++ ){
          let photo = params.action_taken_photos[i];
          formData.append('upload_action_taken_photos[' + i + ']', photo);
        }
      }
      global.axios(`/api/runsheet/remarks/${params.runsheet_id}`, {
          method: "POST",
          data: formData,
          headers: {
            Accept: "application/json",
          },
      })
      .then(response => {
          commit('JobController/updateFollowUp',response.data.data, { root: true });
          resolve( response );
      })
    });
   },
   async resetRemark({commit}, params){
    return new Promise (( resolve, reject ) => {
      let formData = new FormData();
      formData.append('remark_type', params.data.remark_type);
      formData.append('key_of_list', params.data.key_of_list);
      global.axios(`/api/runsheet/remarks/reset/${params.runsheet_id}`, {
         method: "POST",
         data: formData,
         headers: {
            Accept: "application/json",
         },
      })
      .then(response => {
          commit('JobController/updateFollowUp',response.data.data, { root: true });
          resolve( response );
      })
    });
   },
   /*Get checklist group*/
   async getCheckListGroupData({commit}, params){
		return new Promise (( resolve, reject ) => {
		commit( 'setChecklistLoading', true )
		global.axios(`api/checklist-group/list/v2/${params}`, {
			method: "GET",
			headers: {
				Accept: "application/json",
			}
		})
		.then(response => {
			resolve( response )
		})
		.catch(error => reject( error ))
		});
  	},
    /* Checklist Entry */
    async checklistEntriesFollowUp({commit}, params){
      return new Promise (( resolve, reject ) => {
        let formData = new FormData();
        formData.append('remark_id', params.remark_id || '');
        formData.append('is_follow_up', params.is_follow_up || false);
        formData.append('is_keep_next_job', params.is_keep_next_job || false);
        formData.append('preset_actions', params.preset_actions || '');
        formData.append('description', params.data.description || '');
        formData.append('sla_id', params.sla_id || '');
        // formData.append('action_taken_description', params.action_taken_description || '');
        // formData.append('action_taken_date_rectified', params.action_taken_date_rectified || '');

        if(params.action && params.action.photos && params.action.photos.length) {
          for( var i = 0; i < params.action.photos.length; i++ ){
            let photo = params.action.photos[i];
            formData.append('photos[' + i + ']', photo);
          }
        }

        // if(params.action_taken_photos && params.action_taken_photos.length) {
        //   for( var i = 0; i < params.action_taken_photos.length; i++ ){
        //     let photo = params.action_taken_photos[i];
        //     formData.append('upload_action_taken_photos[' + i + ']', photo);
        //   }
        // }
        global.axios(`/api/checklist-entries/follow-up/${params.id}`, {
            method: "POST",
            data: formData,
            headers: {
              Accept: "application/json",
            },
        })
        .then(response => {
            commit('JobController/updateFollowUp',response.data.data, { root: true });
            resolve( response );
        }).catch(error => reject( error ))
      });
    },
    /* Checklist Entry */
    async checklistEntriesToCreateIssue({commit}, params){
      return new Promise (( resolve, reject ) => {
        global.axios(`/api/checklist-entries/issue-register/${params.id}`, {
            method: "POST",
            data: params,
            headers: {
              Accept: "application/json",
            },
        })
        .then(response => {
            resolve( response );
        })
        .catch(error => reject( error ))
      });
    },
    /* clone job */
    async cloneJob({commit}, params){
      return new Promise (( resolve, reject ) => {
          global.axios.post(`api/joblist/clone`, params)
          .then(response => {
            resolve( response.data.data );
          })
          .catch(error => reject( error ));
      });
  },
  async getPreCheckListGroupData({commit}, params){
		return new Promise (( resolve, reject ) => {
		commit( 'setChecklistLoading', true )
		global.axios(`api/checklist-group/list/${params}`, {
			method: "GET",
			headers: {
				Accept: "application/json",
			}
		})
		.then(response => {
			resolve( response )
		})
		.catch(error => reject( error ))
		});
  },
  updatePreCheckListJob({commit}, params){
    return new Promise (( resolve, reject ) => {
      commit( 'setChecklistLoading', true )
      global.axios.put(`/api/checklist-entries/pre-condition/multiple`, params)
          .then(response => {
            commit( 'setChecklistLoading', false )
            resolve( response )
          })
          .catch(error => reject( error ))
    });
  },
};

const mutations = {
  setChecklistLoading (state, data) {
    state.checklistLoading.listing = data
  },
  setError (state, err) {
    state.error = err
  },
  setChecklist (state, data) {
    state.checklist = data
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}